import { router, usePage } from "@inertiajs/react";
import { useEffect, useState } from "react";
import { toast } from "sonner";

/**
 * Hook that handles showing flash messages as toasts using the Inertia flash system.
 * Ensures the component is mounted before showing toasts to avoid SSR hydration issues.
 * Supports toast actions for interactive notifications.
 */
export function useFlashToast() {
  const [mounted, setMounted] = useState(false);
  const page = usePage();
  const flash = page.flash;

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!flash || !mounted) {
      return;
    }

    const action = flash.toastAction;

    const toastOptions = action
      ? {
          action: {
            label: action.label,
            onClick: () => {
              if (action.method && action.method !== "get") {
                router[action.method](action.url);
              } else {
                router.visit(action.url);
              }
            },
          },
        }
      : undefined;

    if (flash.success) {
      toast.success(String(flash.success), toastOptions);
    }

    if (flash.error) {
      toast.error(String(flash.error), toastOptions);
    }

    if (flash.warning) {
      toast.warning(String(flash.warning), toastOptions);
    }

    if (flash.info) {
      toast.info(String(flash.info), toastOptions);
    }

    if (flash.message && !flash.success && !flash.error && !flash.warning && !flash.info) {
      toast.info(String(flash.message), toastOptions);
    }
  }, [flash, mounted]);
}
